export class QRCodeSetting{
    generateVcard: boolean = false;
    sendFollowRequest: boolean = false;
}